import React from 'react'
import * as LucideIcons from 'lucide-react'
import { ArticleBusinessType, CheckoutFlow } from 'admin/articleService'

export type LucideIconName = keyof typeof LucideIcons

export const productTypeIconMap: Record<ArticleBusinessType, LucideIconName> = {
    single_visit_ticket: 'Ticket',
    multi_visit_ticket: 'Ticket',
    visit_reservation: 'TicketCheck',
    food_and_beverage: 'HandPlatter',
    donation: 'HandCoins',
    membership: 'IdCard',
    season_pass: 'IdCard',
    bundle: 'Tickets',
    voucher: 'Tag',
    loyalty_card: 'IdCard',
    service: 'Handshake',
    service_fee: 'HandCoins',
    service_date_change: 'HandCoins',
    upsell: 'TicketPlus',
}

export const categoryTypeIconMap: Record<CheckoutFlow, LucideIconName> = {
    dated: 'CalendarCheck',
    undated: 'CalendarOff',
    date_reservation: 'TicketCheck',
    rtp: 'CalendarDays',
    date_change: 'CalendarSync',
    membership: 'IdCard',
}

interface LucideIconProps {
    iconName?: LucideIconName
    size?: number
    strokeWidth?: number
    className?: string
    title?: string
}

export const LucideIcon: React.FC<LucideIconProps> = ({ iconName, size = 20, strokeWidth = 1.5, className, title }) => {
    if (!iconName) return null

    const IconComponent = LucideIcons[iconName] as any

    if (title) {
        return (
            <span title={title} className={className}>
                <IconComponent size={size} strokeWidth={strokeWidth} absoluteStrokeWidth />
            </span>
        )
    }

    return <IconComponent size={size} strokeWidth={strokeWidth} className={className} absoluteStrokeWidth />
}
